export const DEFAULT_MESSAGE_API_PREFIX = '/system/im'
